import { getRouteParams } from '../../routing/getRouteParams';
import { getHistory } from '../../routing/history';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../../i18n/LocaleUtils';
export const isUserFromPricingPage = () => {
  const {
    queryParams
  } = getRouteParams();
  const hubsSignupUrl = queryParams['hubs_signup-url'];
  const hubsContentUrl = queryParams['hubs_content'];
  const hubsSignupUrlPath = hubsSignupUrl && hubsSignupUrl.split('/')[1];
  const hubsContentUrlPath = hubsContentUrl && hubsContentUrl.split('/')[1];
  const hasSeenPricingPage = hubsSignupUrlPath === 'pricing' || hubsContentUrlPath === 'pricing';
  return hasSeenPricingPage;
};
export const addEnrolmentQueryParamForAcq129 = () => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  searchParams.set('acq129', '1');
  getHistory().replace(`${getHistory().location.pathname}?${searchParams}`);
};
export const hasEnrolmentQueryParamForAcq129 = () => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  const enrolmentQueryParamForAcq129 = searchParams.get('acq129');
  return Boolean(enrolmentQueryParamForAcq129);
};
const ArticleLanguage = {
  [Locale.ja]: 'jp',
  [Locale.ptBr]: 'br',
  [Locale.de]: 'de',
  [Locale.es]: 'es',
  [Locale.fr]: 'fr'
};
export const getLocalisedLink = urlPath => {
  let url = 'https://hubspot';
  const locale = getApplicationLocale();
  const localisedArticleLang = ArticleLanguage[locale];

  if (locale !== Locale.en && localisedArticleLang) {
    if (locale === Locale.pt || locale === Locale.ptBr) {
      url = `https://${ArticleLanguage[locale]}.hubspot.com`;
    } else {
      url = `${url}.${localisedArticleLang}`;
    }
  } else {
    url = `${url}.com`;
  }

  return `${url}${urlPath}`;
};